// components/common/GlobalModal.tsx
import React from 'react';
import { useModalStore } from '@/store/modalStore';
import './GlobalModal.css';

const GlobalModal = () => {
    const isOpen = useModalStore((state) => state.isOpen);
    const type = useModalStore((state) => state.type);
    const title = useModalStore((state) => state.title);
    const message = useModalStore((state) => state.message);
    const { confirm, cancel, closeModal } = useModalStore((state) => state.actions);

    if (!isOpen) return null;

    // 모달 타입별 렌더링
    const renderModalContent = () => {
        switch (type) {
            case 'alert':
                return (
                    <>
                        <div className="modal-icon modal-icon-info">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                                      fill="currentColor"/>
                            </svg>
                        </div>
                        <div className="modal-content">
                            <h3 className="modal-title">{title || '알림'}</h3>
                            <p className="modal-message">{message}</p>
                        </div>
                        <div className="modal-actions">
                            <button className="modal-btn modal-btn-primary" onClick={closeModal}>
                                확인
                            </button>
                        </div>
                    </>
                );

            case 'confirm':
                return (
                    <>
                        <div className="modal-icon modal-icon-question">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                                      fill="currentColor"/>
                            </svg>
                        </div>
                        <div className="modal-content">
                            <h3 className="modal-title">{title || '확인'}</h3>
                            <p className="modal-message">{message}</p>
                        </div>
                        <div className="modal-actions">
                            <button className="modal-btn modal-btn-secondary" onClick={cancel}>
                                취소
                            </button>
                            <button className="modal-btn modal-btn-primary" onClick={confirm}>
                                확인
                            </button>
                        </div>
                    </>
                );

            case 'delete':
                return (
                    <>
                        <div className="modal-icon modal-icon-danger">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2L1 21h22L12 2zm1 16h-2v-2h2v2zm0-4h-2v-4h2v4z"
                                      fill="currentColor"/>
                            </svg>
                        </div>
                        <div className="modal-content">
                            <h3 className="modal-title modal-title-danger">{title || '삭제 확인'}</h3>
                            <p className="modal-message">{message || '정말로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.'}</p>
                        </div>
                        <div className="modal-actions">
                            <button className="modal-btn modal-btn-secondary" onClick={cancel}>
                                취소
                            </button>
                            <button className="modal-btn modal-btn-danger" onClick={confirm}>
                                삭제
                            </button>
                        </div>
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <>
            {/* 배경 오버레이 */}
            <div
                className="modal-overlay"
                onClick={type === 'alert' ? closeModal : undefined}
            />

            {/* 모달 컨텐츠 */}
            <div className={`modal-container modal-${type}`}>
                {renderModalContent()}
            </div>
        </>
    );
};

export default GlobalModal;